import { CaseTypes } from '@portalCommon/constants';
import classnames from 'classnames/bind';
import { PageTop, TopCard, Demand, Features, Process, Advantage, SuccessCases } from '../components/';
import styles from '../index.module.less';

const cx = classnames.bind(styles);

export const IndustrySubmmit = ({ type }: { type: CaseTypes }) => {
  return (
    <>
      <PageTop
        title="行业峰会解决方案"
        brief="融合场景定制、会议组织、线上社交等功能的一站式行业峰会场景方案，等你体验。"
        bg="https://static.fuxi.netease.com/yaotai/portal/20220905/l7ohfgtv_385714.png"
      />
      <div className={cx('top-module')}>
        <TopCard type={type}></TopCard>
        <Demand type={type} title={['行业峰会', '核心诉求']} />
      </div>
      <Features type={type} title={['行业峰会', '特色功能']} subtitle="丰富功能，满足行业峰会场景需求" />
      <Process></Process>
      <Advantage type={type} title={['行业峰会', '方案优势']}></Advantage>
      <SuccessCases type={type} title={['成功案例']} subtitle="精彩多样的元宇宙活动，您也可以拥有"></SuccessCases>
    </>
  );
};
